import { formatMoney } from "./formatter";
import { isAssetImageLocalOnlyBySegments } from "./asset-image-public-prefixes";
import { getClientAssetImageScope } from "./asset-image-scope";

export * from "./formatter";
export * from "./image";
export * from "./asset-image-public-prefixes";
export * from "./asset-image-scope";

export * from "./validators/regex";
export * from "./validators/validator";

const DEFAULT_S3_PUBLIC_BASE = "https://s3.ap-southeast-1.amazonaws.com/simplify.salify";

function decodeClientGlobalCookie(): { orgId?: string; tenantId?: string } | null {
  if (typeof document === "undefined") return null;
  const rawCookie = document.cookie
    .split(";")
    .map((v) => v.trim())
    .find((v) => v.startsWith("_sgd_="));
  if (!rawCookie) return null;
  const encoded = rawCookie.slice(rawCookie.indexOf("=") + 1).trim();
  if (!encoded) return null;
  try {
    const value = decodeURIComponent(encoded);
    const decoded = globalThis.atob(value);
    return JSON.parse(decoded) as { orgId?: string; tenantId?: string };
  } catch {
    return null;
  }
}

function resolveAssetScope() {
  const runtimeScope = getClientAssetImageScope();
  const cookieScope = decodeClientGlobalCookie();
  const orgId =
    runtimeScope?.orgId || cookieScope?.orgId || process.env.NEXT_PUBLIC_SIMPLIFY_ORG_ID;
  const tenantId =
    runtimeScope?.tenantId || cookieScope?.tenantId || process.env.NEXT_PUBLIC_SIMPLIFY_TENANT_ID;
  return { orgId, tenantId };
}

export function toAssetImages(path: string) {
  if (typeof path !== "string") return "#";
  const s = path.trim();
  const s3Base = (process.env.NEXT_PUBLIC_S3_PUBLIC_BASE || DEFAULT_S3_PUBLIC_BASE).replace(
    /\/$/,
    "",
  );

  if (/^https?:\/\//i.test(s)) {
    if (s.startsWith(`${s3Base}/`)) {
      const rel = s.slice(s3Base.length + 1);
      return `/assets/images/${rel}`;
    }
    return s;
  }

  const noLeading = s.startsWith("/") ? s.slice(1) : s;
  const rel = noLeading.startsWith("assets/images/")
    ? noLeading.slice("assets/images/".length)
    : noLeading;
  const segments = rel.split("/").filter(Boolean);
  if (isAssetImageLocalOnlyBySegments(segments)) {
    return `/assets/images/${rel}`;
  }

  const { orgId, tenantId } = resolveAssetScope();
  if (!orgId || !tenantId) {
    return `/assets/images/${rel}`;
  }

  const safeRel = segments.map((v) => encodeURIComponent(v)).join("/");
  return `/assets/images/${encodeURIComponent(orgId)}/${encodeURIComponent(tenantId)}/${safeRel}`;
}

export function calculateDiscount(price: number, discount: number) {
  const afterDiscount = Number((price - price * (discount / 100)).toFixed(0));
  return formatMoney(afterDiscount);
}
